import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppLoginComponent} from './pages/app.login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './helps/auth.guards';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {path: 'login', component: AppLoginComponent},
            {path: '', component: AppMainComponent, canActivate: [AuthGuard],
                children: [
                     {path: '', component: DashboardComponent, canActivate: [AuthGuard]},
                ]},
            {path: 'notfound', component: AppNotfoundComponent},
            {path: '**', redirectTo: '/notfound'},
        ], {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule {
    
}
